import {
  dateOperators,
  equalityOperators,
  multiselectOperators,
  textOperators
} from '../../../utils/constants/operators'
import * as constants from '../../../utils/constants/constants'

export const supplierColumns = [
  {
    name: 'supplier_name',
    label: 'Nom Fournisseur',
    isFilter: true,
    operators: textOperators
  },
  {
    name: 'city',
    label: 'Ville',
    isFilter: true,
    operators: textOperators
  },
  {
    name: 'createdDateTime',
    label: 'Date Création',
    isFilter: true,
    inputType: 'datetime-local',
    type: 'date',
    format: 'DD/MM/YYYY HH:mm:ss',
    operators: dateOperators
  },
  {
    name: 'createdBy',
    label: 'Créé Par',
    isFilter: true,
    operators: [...equalityOperators, ...multiselectOperators]
  },
  {
    name: 'lastModDateTime',
    label: 'Date Modification',
    isFilter: true,
    inputType: 'datetime-local',
    type: 'date',
    format: 'DD/MM/YYYY HH:mm:ss',
    operators: dateOperators
  },
  {
    name: 'lastModBy',
    label: 'Modifié Par',
    isFilter: true,
    operators: [...equalityOperators, ...multiselectOperators]
  }
]

export const getSupplierFields = () => [
  [
    {
      name: 'supplier_name',
      label: 'Nom',
      required: true,
      type: 'text',
      fullWidth: true,
      validation: [
        {
          rule: 'req',
          error: 'Nom obligatoire'
        },
        {
          rule: 'minlen=3',
          error: 'Nom doit contenir au moins 3 caractères'
        },
        {
          rule: 'maxlen=20',
          error: 'Nom doit contenir moins de 20 caractères'
        }
      ]
    }
  ],
  [
    {
      name: 'address1',
      label: 'Adresse',
      type: 'text',
      fullWidth: true
    }
  ],
  [
    {
      name: 'address2',
      label: "Complément d'adresse",
      type: 'text',
      fullWidth: true
    }
  ],
  [
    {
      name: 'zip',
      label: 'Code Postal',
      type: 'text',
      fullWidth: true
    },
    {
      name: 'city',
      label: 'Ville',
      type: 'text',
      fullWidth: true
    }
  ],
  [
    {
      name: 'phone',
      label: 'Téléphone',
      type: 'text',
      fullWidth: true,
      validation: [
        {
          rule: 'len=10',
          error: 'Téléphone doit contenir 10 chiffres'
        },
        {
          rule: `regex=${constants.REGEX_PHONE.source}`,
          error: 'Téléphone doit contenir uniquement des chiffres'
        }
      ]
    },
    {
      name: 'email',
      label: 'Email',
      type: 'text',
      fullWidth: true,
      validation: [
        {
          rule: 'email',
          error: 'Email format'
        }
      ]
    }
  ]
]
